import { routes } from "../../constants/api-routes";
import { networkService } from "../../networking/network-services";
import { methods } from "../../utils/methods";
import showToast from "../../utils/toast";

// export const loginWithEmail = async (payload: any): Promise<any> => {
//   try {
//     const { data, status } = await networkService.request({
//       method: methods.post,
//       url: routes.authentication.loginEmail,
//       data: payload,
//       skipAuth: true,
//     });
//     if (status === 200) {
//       showToast("logged in successfully", "s");
//       return { data, status };
//     } else {
//       return false;
//     }
//   } catch (error: any) {
//     console.log("error",error);
//     showToast("Invalid credentials", "e");
//     return false;
//   }
// };

export const loginWithEmail = async (payload: any): Promise<any> => {
  try {
    const { data, status } = await networkService.request({
      method: methods.post,
      url: routes.authentication.loginEmail,
      data: payload,
      skipAuth: true,
    });

    if (status === 200) {
      showToast("Logged in successfully", "s");
      return { data, status };
    }

    return false;
  } catch (error: any) {
    const message =
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong";
    showToast(message, "e");
    return { error };
  }
}

export const sendPasswordResetOtp = async (payload: any): Promise<any> => {
  try {
    const { data, status } = await networkService.request({
      method: methods.post,
      url: routes.authentication.passwordResetSend,
      data: payload,
    });
    if (status === 200) {
      showToast(data?.response || data?.message || "OTP sent successfully", "s");
      return { data, status };
    }
    return false;
  } catch (error: any) {
    showToast(
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong, please try again",
      "e"
    );
    return false;
  }
};

export const confirmPasswordReset = async (payload: any): Promise<any> => {
  try {
    const { data, status } = await networkService.request({
      method: methods.post,
      url: routes.authentication.passwordResetConfirm,
      data: payload,
    });
    if (status === 200) {
      showToast(data?.response || data?.message || "Password reset successfully", "s");
      return { data, status };
    }
    return false;
  } catch (error: any) {
    showToast(
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong, please try again",
      "e"
    );
    return false;
  }
};

// Runs after the local session is already cleared, so it carries its own
// token and skips the 401 refresh path: a dead session must not pop an
// "expired" toast on the login page.
export const logOutFromServer = async (payload: any, accessToken?: string): Promise<any> => {
  try {
    const { data, status } = await networkService.request({
      method: methods.post,
      url: routes.authentication.logOut,
      data: payload,
      timeout: 15000,
      _retry: true,
      headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
    });
    return status === 200 ? data : false;
  } catch (error) {
    return false;
  }
};